import { ConvertHistoryParams } from 'api/v1/convert'
import { ApiHistoryItem } from 'api/v1/txHistory'
import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState, useAppDispatch } from 'store'
import { useAccountId, useAccountInfo, useIsLogin } from 'store/account/hooks'
import { EthHashItem } from 'store/deposit/types'
import {
  getConvertHistoryAction,
  getDepositHistoryAction,
  getTransferHistoryAction,
  getWithdrawHistoryAction,
} from './actions'
import { CloseOrderBody, HistoryState, TradeHistoryBody } from './types'
import { TransactionsFilterParams } from 'api/v1/transactions'

export function useCloseOrdersHistory() {
  return useSelector<RootState, CloseOrderBody>(
    (state) => state.history.closedOrders,
  )
}
export function useTradeHistory() {
  return useSelector<RootState, TradeHistoryBody>(
    (state) => state.history.trades,
  )
}
export function useDepositList() {
  return useSelector<RootState, ApiHistoryItem[]>(
    (state) => state.history.deposit.results,
  )
}
export function useDepositTransactions() {
  return useSelector<RootState, HistoryState['deposit']>(
    (state) => state.history.deposit,
  )
}
export function useDepositEthHash() {
  return useSelector<RootState, EthHashItem[]>((state) => state.deposit.ethHash)
}
export function useWithdrawList() {
  return useSelector<RootState, ApiHistoryItem[]>(
    (state) => state.history.withdraw.results,
  )
}
export function useWithdrawTransactions() {
  return useSelector<RootState, HistoryState['withdraw']>(
    (state) => state.history.withdraw,
  )
}
export function useWithdrawL2SuccessTxHash() {
  const withdrawList = useSelector<RootState, ApiHistoryItem[]>(
    (state) => state.history.withdraw.results,
  )
  const useWithdrawL2Success = withdrawList?.filter(
    (item) => item?.txStatus === 'SUCCESS',
  )
  return useWithdrawL2Success?.map((item) => item?.txHash)
}
export function useWithdrawTxHash() {
  const withdrawList = useSelector<RootState, ApiHistoryItem[]>(
    (state) => state.history.withdraw.results,
  )
  return withdrawList?.map((item) => item?.txHash)
}
export function useTransferList() {
  return useSelector<RootState, ApiHistoryItem[]>(
    (state) => state.history.transfer.results,
  )
}
export function useTransferTransactions() {
  return useSelector<RootState, HistoryState['transfer']>(
    (state) => state.history.transfer,
  )
}
export function useHistoryConvert() {
  return useSelector<RootState, HistoryState['convert']>(
    (state) => state.history.convert,
  )
}
export function useFetchConvertHistory(params: ConvertHistoryParams) {
  const dispatch = useAppDispatch()
  const isLogin = useIsLogin()
  const { accountId } = useAccountInfo()

  const fetchConvertHistory = useCallback(() => {
    if (!isLogin) {
      return
    }
    // getConvertHistory(accountId!, params)
    dispatch(getConvertHistoryAction(params))
  }, [dispatch, isLogin, params, accountId])

  useEffect(() => {
    if (accountId === undefined) {
      return
    }
    return fetchConvertHistory()
  }, [fetchConvertHistory, accountId])

  return {
    fetchConvertHistory,
  }
}

export function useFetchDepositHistory({
  offsetId,
  limit,
  days,
  currency,
  status,
  txHash,
}: TransactionsFilterParams) {
  const dispatch = useAppDispatch()
  const accountId = useAccountId()

  useEffect(() => {
    if (accountId === undefined) {
      return
    }
    dispatch(
      getDepositHistoryAction({
        offsetId,
        limit,
        days,
        currency,
        status,
        txHash,
      }),
    )
  }, [accountId, offsetId, limit, days, currency, status, txHash])

  // useInterval(
  //   () => {
  //     dispatch(getDepositHistoryAction({ offsetId, limit, currency, status }))
  //   },
  //   accountId !== undefined ? 1000 * 30 : null,
  // )
}

export function useFetchWithdrawHistory({
  offsetId,
  limit,
  days,
  currency,
  status,
  txHash,
}: TransactionsFilterParams) {
  const dispatch = useAppDispatch()
  const accountId = useAccountId()

  useEffect(() => {
    if (accountId === undefined) {
      return
    }
    dispatch(
      getWithdrawHistoryAction({
        offsetId,
        limit,
        days,
        currency,
        status,
        txHash,
      }),
    )
  }, [accountId, offsetId, days, limit, currency, status, txHash])

  // useInterval(
  //   () => {
  //     dispatch(getDepositHistoryAction({x offsetId, limit, currency, status }))
  //   },
  //   accountId !== undefined ? 1000 * 30 : null,
  // )
}

export function useFetchTransferHistory({
  offsetId,
  limit,
  days,
  currency,
  status,
  txHash,
}: TransactionsFilterParams) {
  const dispatch = useAppDispatch()
  const accountId = useAccountId()

  useEffect(() => {
    if (accountId === undefined) {
      return
    }
    dispatch(
      getTransferHistoryAction({
        offsetId,
        limit,
        days,
        currency,
        status,
        txHash,
      }),
    )
  }, [accountId, offsetId, limit, days, currency, status, txHash])

  // useInterval(
  //   () => {
  //     dispatch(getDepositHistoryAction({ offsetId, limit, currency, status }))
  //   },
  //   accountId !== undefined ? 1000 * 30 : null,
  // )
}
